(() => {
  'use strict';
  if (customElements.get('region-loading')) return;

  class RegionLoading extends HTMLElement {
    static get observedAttributes() { return ['loading']; }

    connectedCallback() { this.update(); }
    attributeChangedCallback() { this.update(); }

    setLoading(value) { this.toggleAttribute('loading', Boolean(value)); }

    update() {
      const content = this.querySelector(':scope > [data-region-content]');
      const status = this.querySelector(':scope > [data-region-status]');
      if (!content || !status) return;
      const loading = this.hasAttribute('loading');
      if (loading && content.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      content.inert = loading;
      content.setAttribute('aria-busy', String(loading));
      status.hidden = !loading;
    }
  }

  customElements.define('region-loading', RegionLoading);
})();
